module.exports = __webpack_public_path__ + "media/images/icon__questionmark--rb-light-gray-b1d3ff24d8e1551ea3947c2fb8ad3cab.png";